import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=8e945606&scoped=true&"
import script from "./videoPlay.vue?vue&type=script&lang=js&"
export * from "./videoPlay.vue?vue&type=script&lang=js&"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=8e945606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e945606",
  null
  
)

export default component.exports